// Entry point
import './styles/main.css';
import { initApp } from './app.js';
import { tracker } from '@services/analytics/tracker.js';

// Initialize the application when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  tracker.init();
  initApp();
});
